<template>
  <div class="c-archive">
    <section class="main-section">
      <p class="btn-item" v-if="isPermission('Admin')" style="display: none">
        <router-link
          :to="{
            name: 'admin_archive_edit',
            params: { mc_code: currentUser.mansion._id, id: 'create' },
          }"
        >
          <button type="button" class="el-button el-button--primary">
            <i class="el-icon-circle-plus"></i><span>新規書類追加</span>
          </button>
        </router-link>
      </p>

      <PageTitle
        titleText="書庫（規約・議事録 他）"
        asideText="マンションに関する書類等を閲覧・ダウンロードできます。"
        asideText2="※印は外部サイトリンクです（別ウインドウが開きます）"
      />
    </section>
    <!--/.main-section-->

    <section class="c-archive__buttons" v-if="isPermission('Admin')">
      <div
        v-for="(item, index) in categories"
        :key="index"
        :class="`archive${item._id}`"
        class="c-archive__button"
      >
        <router-link
          :to="{
            name: 'archive-list',
            params: { category: item._id, mc_code: currentUser.mansion._id },
          }"
        >
          <Button :text="item.title"></Button>
        </router-link>
      </div>
    </section>

    <section class="main-section buttons cloumBtns" v-else>
      <p
        class="section-block center"
        v-for="(item, index) in norm_categories"
        :key="index"
        :class="`archive${item._id}`"
      >
        <router-link
          :to="{
            name: 'archive-list',
            params: { category: item._id, mc_code: currentUser.mansion._id },
          }"
        >
          <button class="bt bt-green">
            {{ item.title }}
          </button>
        </router-link>
      </p>
    </section>
    <!--/.main-section-->

    <!-- <IconMenu /> -->
    <!--/.main-section-->
    <div class="c-archive-list__closeButtonWrap">
      <a
        href="https://mc.mansion-concierge.com/"
        class="c-archive-list__closeButton"
      >
        <Button text="トップページへ"></Button>
      </a>
    </div>
  </div>
  <!--/.main-->
</template>

<script>
import CategoryService from "../../services/category.service";
import ArchiveService from "../../services/archive.service";
import PageTitle from "@/components/PageTitle.vue";
import Button from "@/components/Button.vue";
export default {
  name: "archive-index",
  components: {
    PageTitle,
    Button,
  },
  // components: { IconMenu },
  data: function() {
    return {
      categories: [],
      counter: [],
    };
  },
  computed: {
    norm_categories() {
      return this.categories.filter((elem, index) => {
        return this.counter[index] != 0;
      });
    },
  },
  mounted: async function() {
    try {
      console.log("+++ mountd");
      const count = await ArchiveService.count();
      this.counter = count.data;
      console.log(this.counter);
      const res = await CategoryService.get();
      console.log(res);
      this.categories = res.data;
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style scoped>
.bt-blue {
  background-color: #76a5b2;

  display: inline-block;
  border: none;
  border-radius: 5px;
  box-sizing: border-box;
  min-width: 100%;
  min-height: 44px;
  color: #fff;
  font-size: 140%;
  font-weight: bold;
}
</style>
